
import React from 'react';
import { Text, View } from '@coinscrap/webapp-core';

import { OptionButton } from 'components/OptionButton/OptionButton';
import TooltipSimple from 'components/TooltipSimple/TooltipSimple';

const QuestionnaireBox = ({
	text,
	tooltipText,
	onChange,
	value = null,
	listWithTooltips = false,
}) => {
	console.log(value);
	return (
		<View questionnariesSt>
			<View wrapperQuestionnariesSt>
				<Text headingTertiarySt>
					<View
						wrapperTextQuestionnariesSt
						style={{ width: listWithTooltips ? '90%' : '100%' }}
					>
						{text}
					</View>
					{tooltipText && (
						<View style={{ width: '10%' }}>
							<TooltipSimple>
								<Text tooltipTextSt>{tooltipText}</Text>
							</TooltipSimple>
						</View>
					)}
				</Text>
			</View>
			<View wrapperButtonsQuestionnariesSt>
				<OptionButton
					style={{ marginRight: 20 }}
					onClick={() => onChange(true)}
					selected={!value}
					text={'Sí'}
					width={142}
				/>
				<OptionButton
					onClick={() => onChange(false)}
					selected={value || value == null}
					text={'No'}
					width={142}
				/>
			</View>
		</View>
	);
};

export default QuestionnaireBox;
